// Third Party
import React from 'react';
import classNames from 'classnames';

// Components
import Button, { ButtonProps } from './Button';

const PillButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, children, icon, ...rest }, ref) => (
  <Button className={classNames(className, 'pill-button')} icon={icon} ref={ref} {...rest}>
    {children}
  </Button>
));

export default PillButton;
